enum SearchReportRequest {
  Total = 'SEARCH_TOTAL',

  Date = 'SEARCH_DATE',
  Platform = 'SEARCH_PLATFORM',
  Advertiser = 'SEARCH_ADVERTISER',
  Campaign = 'SEARCH_CAMPAIGN',
  AdGroup = 'SEARCH_AD_GROUP',
  Keyword = 'SEARCH_KEYWORD',
}

export default SearchReportRequest;
